import type { ComboboxItem } from '@screentone/core';

export const stringToComboboxItem = (value: string): ComboboxItem => ({ id: value, label: value, value });

export const stringsToComboboxItems = (values: string[]): ComboboxItem[] => values.map(stringToComboboxItem);

export const resolveComboboxUpdate = (
  update: ComboboxItem[] | ((prev: ComboboxItem[]) => ComboboxItem[]),
  prev: ComboboxItem[]
): ComboboxItem[] => (typeof update === 'function' ? update(prev) : update);
